// @flow
import { combineReducers } from 'redux';
import { reducer as countries } from './countries';
import { reducer as taxRates } from './taxRates';

export default combineReducers({
  countries,
  taxRates,
});
